import { Grid } from "@mui/material";
import EcommerceMetrix from "components/cards/statistics/EcommerceMetrix";
import {
  BookOutlined,
  ReadOutlined,
  TagsOutlined,
  TeamOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import IssuedItemChart from "./IssuedItemChart";
import { GetGeneralDashboard } from "../api/hooks";
const GeneralCard = () => {
  const { data: getQuery } = GetGeneralDashboard();

  function formatNumberWithCommas(num?: number) {
    return num?.toLocaleString("en-IN");
  }

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} lg={2} md={4} sm={6}>
          <EcommerceMetrix
            primary="Today Visitors"
            secondary={formatNumberWithCommas(
              getQuery?.apiData?.data[0]?.totalUniqueVisitorsToday,
            )}
            color="#ff9800"
            iconPrimary={UserSwitchOutlined}
          />
        </Grid>
        <Grid item xs={12} lg={2} xl={2} md={4} sm={6}>
          <EcommerceMetrix
            primary="Today Issued"
            secondary={formatNumberWithCommas(
              getQuery?.apiData?.data[0]?.totalMatAccessionIssueToday,
            )}
            color="error.main"
            iconPrimary={BookOutlined}
          />
        </Grid>
        <Grid item xs={12} lg={2} md={4} sm={6}>
          <EcommerceMetrix
            primary="Today Return"
            secondary={formatNumberWithCommas(
              getQuery?.apiData?.data[0]?.totalMatAccessionReturnToday,
            )}
            color="success.main"
            iconPrimary={BookOutlined}
          />
        </Grid>
        <Grid item xs={12} lg={2} md={4} sm={6}>
          <EcommerceMetrix
            primary="Members"
            secondary={formatNumberWithCommas(
              getQuery?.apiData?.data[0]?.totalMember,
            )}
            color="primary.main"
            iconPrimary={TeamOutlined}
          />
        </Grid>
        <Grid item xs={12} lg={2} md={4} sm={6}>
          <EcommerceMetrix
            primary="Material"
            secondary={formatNumberWithCommas(
              getQuery?.apiData?.data[0]?.totalMaterial,
            )}
            color="info.main"
            iconPrimary={ReadOutlined}
          />
        </Grid>
        <Grid item xs={12} lg={2} md={4} sm={6}>
          <EcommerceMetrix
            primary="Accession"
            secondary={formatNumberWithCommas(
              getQuery?.apiData?.data[0]?.totalMaterialAccession,
            )}
            color="#673ab7"
            iconPrimary={TagsOutlined}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} md={12}>
          <IssuedItemChart />
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <MemberChart />
        </Grid> */}
      </Grid>
    </>
  );
};

export default GeneralCard;
